import _ from "lodash"
import { useMemo } from "react"
import { selectCanRedo, selectCanUndo, selectUndoable } from "../helpers/selector.helpers"
import { useAppSelector } from "./useRedux"

export const useCheckEditor = () => {
    const graphic = useAppSelector((state) => state.graphic)
    const assets = useAppSelector((state) => state.assets.data)
    const noObjects = useAppSelector(
        (state) => Object.keys(selectUndoable(state).objects.value).length === 0
    )
    const isTimelineSettingChanged = useAppSelector(
        (state) => state.editor.value.isTimelineSettingChanged
    )

    const { visibleSaveForm } = useAppSelector((state) => state.editor.value)
    const canUndo = useAppSelector((state) => selectCanUndo(state))
    const canRedo = useAppSelector((state) => selectCanRedo(state))

    const matchAssetsAndGraphicAssets = useMemo(() => {
        if (graphic.data.assetsRef) {
            return _.isEqual(
                graphic.data.assetsRef.map((ref) => ref.id),
                assets.map((asset) => asset._id)
            )
        } else {
            return false
        }
    }, [assets, graphic.data])

    const disabledShortSave = useMemo(() => {
        const hasAssets = assets.length > 0

        // 1. Graphic not saved yet, graphic.data.assetsRef is empty/undefined or add object
        if (!graphic.data.assetsRef) {
            if (hasAssets || !noObjects) {
                return false
            }
            return true
        }

        // 2. Graphic saved, check if assets match
        if (noObjects) {
            return matchAssetsAndGraphicAssets
        }

        if (!matchAssetsAndGraphicAssets || isTimelineSettingChanged) {
            return false
        }
        return visibleSaveForm || !(canUndo || canRedo)
    }, [
        assets.length,
        canRedo,
        canUndo,
        graphic.data.assetsRef,
        isTimelineSettingChanged,
        matchAssetsAndGraphicAssets,
        noObjects,
        visibleSaveForm,
    ])

    return {
        matchAssetsAndGraphicAssets,
        disabledShortSave,
    }
}
